import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as LotActionType from "../constants";
import { Tab, Row, Col } from "react-bootstrap";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import "../maintainance.scss";
import MaintenanceCard from "../../HomeOwners/Components/MaintenanceCard";
import Moment from "moment";
import Drawer from "../../components/Drawer/Drawer";
import * as NotifyActionType from "../../Notification/constants";

const CHOICE_LIST = [
  { value: 0, text: "This month" },
  { value: 1, text: "Next month" },
  { value: 2, text: "Last month" },
  { value: 3, text: "Semi-Annual (Past)" },
  { value: 4, text: "Semi-Annual (Future)" },
  { value: 5, text: "Annual (Past)" },
  { value: 6, text: "Annual (Future)" },
];

const STATUS_LIST = [
  { value: 1, text: "Active" },
  { value: 2, text: "Overdue" },
  { value: 3, text: "Closed" },
];

const ReminderFrequency = [
  { value: 1, text: "Annually" },
  { value: 2, text: "SemiAnnually" },
  { value: 3, text: "Monthly" },
];

class HomeOwnerMaintainance extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array,
    homeownerLotSelectList: PropTypes.array,
    projectId: PropTypes.any,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      activeKey: "1",
      lot: null,
      itemEdit: null,
      documentCategory: null,
      selectedCategory: null,
      show: false,
      selectedFilter: "All",
      title: "",
      reminder_period: 0,
      property: "",
      inventory: "",
      frequency: "",
      statusData: STATUS_LIST.map((s) => s.value),
      searchQuery: "",
      sortAscending: false,
      lotSortAscending: false,
      selectedType: null,
      fromDate: null,
      toDate: null,
      isLoading: false,
      dateValidationError: "",
      /* Create / Update reminder */
      itemListBasedOnLots: null,
      remindersList: null,
      Title: null,
      Description: null,
      LotId: null,
      ItemId: null,
      Frequency: null,
      StartDate: null,
      EndDate: null,
      maintenanceId: null,
      errorMessage: "",
      defaultLot: null,
      defaultLotFetched: false, // Add flag to track if default lot is fetched
    };
    this.selectedType = CHOICE_LIST[0];
    this.selectedStatus = STATUS_LIST[3];
    this.statusDropdownRef = React.createRef();
  }

  componentDidMount() {
    this.fetchLot();
    this.onChangeFromToDate(CHOICE_LIST[0]);
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideStatusDropdown
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!prevState.lot && this.state.lot) ||
      prevState.statusData !== this.state.statusData ||
      prevState.fromDate !== this.state.fromDate ||
      prevState.toDate !== this.state.toDate
    ) {
      this.getAllReminder();
    }

    // Check if we need to set default lot when both conditions are met
    if (
      !prevState.defaultLotFetched &&
      this.state.defaultLotFetched &&
      this.props.homeownerLotSelectList.length > 0 &&
      !this.state.lot
    ) {
      this.setDefaultLot();
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideStatusDropdown
    );
  }

  componentWillReceiveProps(nextProps) {
    // Handle when homeownerLotSelectList is received
    if (nextProps.homeownerLotSelectList.length && !this.state.lot) {
      if (this.state.defaultLotFetched && this.state.defaultLot) {
        // If we already have defaultLot, set it immediately
        this.setDefaultLotFromList(nextProps.homeownerLotSelectList);
      } else if (!this.state.defaultLot) {
        // If no defaultLot yet, check URL params or set first lot
        const lotId = this.lotId;
        if (lotId) {
          let currentLot = nextProps.homeownerLotSelectList.find(
            (l) => l.value === lotId
          );
          if (currentLot) {
            this.setState(
              {
                lot: currentLot,
                LotId: currentLot,
              },
              () => {
                this.getAllReminder();
              }
            );
          }
        } else {
          // Set first lot as fallback only if defaultLot fetch is complete and no default found
          if (this.state.defaultLotFetched) {
            this.setState(
              {
                lot: nextProps.homeownerLotSelectList[0],
                LotId: nextProps.homeownerLotSelectList[0],
              },
              () => {
                this.getAllReminder();
              }
            );
          }
        }
      }
    }
  }

  // New method to set default lot when both defaultLot and homeownerLotSelectList are available
  setDefaultLot = () => {
    const { homeownerLotSelectList } = this.props;
    const { defaultLot } = this.state;

    if (homeownerLotSelectList && homeownerLotSelectList.length > 0) {
      if (defaultLot) {
        this.setDefaultLotFromList(homeownerLotSelectList);
      } else {
        // If no default lot, select the first one
        this.setState(
          {
            lot: homeownerLotSelectList[0],
            LotId: homeownerLotSelectList[0],
          },
          () => {
            this.getAllReminder();
          }
        );
      }
    }
  };

  // Helper method to set default lot from the list
  setDefaultLotFromList = (lotSelectList) => {
    let templot = lotSelectList.find((l) => l.value === this.state.defaultLot);
    if (templot) {
      this.setState(
        {
          lot: templot,
          LotId: templot,
        },
        () => {
          this.getAllReminder();
        }
      );
    }
  };

  handleClickOutsideStatusDropdown = (event) => {
    if (
      this.state.statusMenuOpen &&
      this.statusDropdownRef.current &&
      !this.statusDropdownRef.current.contains(event.target)
    ) {
      this.setState({ statusMenuOpen: false });
    }
  };

  handleOpenModal = () => {
    this.setState({
      show: true,
      maintenanceId: null,
    });
    this.getItemListBasedOnLots();
  };

  handleCloseModal = () => {
    this.setState({
      show: false,
      Title: "",
      Description: "",
      ItemId: null,
      Frequency: null,
      StartDate: "",
      EndDate: "",
      maintenanceId: null,
      itemListBasedOnLots: null,
      errorMessage: "",
      dateValidationError: "",
    });
  };

  toggleStatusDropdown = () => {
    this.setState((prevState) => ({
      statusMenuOpen: !prevState.statusMenuOpen,
    }));
  };

  handleStatusCheckboxChange = (value) => {
    const { statusData } = this.state;
    const isSelected = statusData.includes(value);
    const updated = isSelected
      ? statusData.filter((v) => v !== value)
      : [...statusData, value];

    this.setState({ statusData: updated }, () => {
      this.getAllReminder();
    });
  };

  onEditTabName = (item) => {
    this.setState({
      itemEdit: item,
    });
  };

  fetchLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC,
    });
    this.props.dispatch({
      type: LotActionType.GET_DEFAULT_LOT,
      callback: (response) => {
        if (response && response.data && response.data.lotId) {
          this.setState(
            {
              defaultLot: response.data.lotId,
              defaultLotFetched: true,
            },
            () => {
              if (
                this.props.homeownerLotSelectList.length > 0 &&
                !this.state.lot
              ) {
                this.setDefaultLot();
              }
            }
          );
        } else {
          this.setState({
            defaultLotFetched: true,
          });
        }
      },
    });
  };

  onSelectLot = (event, fieldname) => {
    this.setState(
      {
        lot: event.value,
        lotId: event.value,
      },
      () => {
        if (fieldname === "lot") {
          this.getAllReminder();
          this.onSelectLotID(event);
        }
      }
    );
  };

  onSelectLotID = (event) => {
    this.setState(
      {
        LotId: event.value,
      },
      () => {
        this.getItemListBasedOnLots();
      }
    );
  };

  onSelectItemID = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  onSelectScheduled = (event) => {
    this.setState({
      lot: event.value,
    });
  };

  onCancelEdit = () => {
    this.setState({
      itemEdit: null,
    });
  };

  sortCategoryByName = () => {
    const { lotSortAscending, documentCategory } = this.state;
    if (!documentCategory || !documentCategory.data) return;

    const sortedCategoryData = [...documentCategory.data].sort((a, b) => {
      const nameA = a.text.toLowerCase();
      const nameB = b.text.toLowerCase();
      if (nameA < nameB) return lotSortAscending ? -1 : 1;
      if (nameA > nameB) return lotSortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      documentCategory: {
        ...documentCategory,
        data: sortedCategoryData,
      },
      lotSortAscending: !lotSortAscending,
    });
  };

  filterRemindersBySearch = (reminders, searchQuery) => {
    if (!searchQuery) return reminders;
    const query = searchQuery.toLowerCase();
    return reminders.filter((item) => {
      return (
        (item.title && item.title.toLowerCase().includes(query)) ||
        (item.description && item.description.toLowerCase().includes(query)) ||
        (item.status && item.status.toLowerCase().includes(query)) ||
        (item.remindDate &&
          item.remindDate.toString().toLowerCase().includes(query))
      );
    });
  };

  handleFilterClick = (filter) => {
    this.setState({ selectedFilter: filter });
  };

  getFilteredReminders = () => {
    const { remindersList, selectedFilter, searchQuery } = this.state;
    if (!Array.isArray(remindersList)) return [];

    let filtered = remindersList;

    if (selectedFilter === "HomeHub") {
      filtered = filtered.filter((item) => item.isBuilderUploaded === true);
    } else if (selectedFilter === "YourReminders") {
      filtered = filtered.filter((item) => item.isBuilderUploaded === false);
    }
    if (searchQuery && searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (item) => item.title && item.title.toLowerCase().includes(query)
      );
    }

    return filtered;
  };

  // Helper functions for date calculations
  getMonthStartDate = (year, month) => {
    return new Date(year, month, 1);
  };

  getMonthEndDate = (year, month) => {
    return new Date(year, month + 1, 0);
  };

  formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00.000Z`;
  };

  getDateRange = (option, referenceDate = new Date()) => {
    const year = referenceDate.getFullYear();
    const month = referenceDate.getMonth(); // 0-based

    let fromDate;
    let startDate;

    if (option === "This month") {
      fromDate = this.getMonthStartDate(year, month);
      startDate = this.getMonthEndDate(year, month);
    } else if (option === "Last month") {
      fromDate = this.getMonthStartDate(year, month - 1);
      startDate = this.getMonthEndDate(year, month - 1);
    } else if (option === "Next month") {
      fromDate = this.getMonthStartDate(year, month + 1);
      startDate = this.getMonthEndDate(year, month + 1);
    } else if (option === "Semi-Annual (Past)") {
      fromDate = new Date(referenceDate);
      fromDate.setMonth(fromDate.getMonth() - 6);
      startDate = new Date(referenceDate);
    } else if (option === "Semi-Annual (Future)") {
      fromDate = new Date(referenceDate);
      startDate = new Date(referenceDate);
      startDate.setMonth(startDate.getMonth() + 6);
    } else if (option === "Annual (Past)") {
      fromDate = new Date(referenceDate);
      fromDate.setFullYear(fromDate.getFullYear() - 1);
      startDate = new Date(referenceDate);
    } else if (option === "Annual (Future)") {
      fromDate = new Date(referenceDate);
      startDate = new Date(referenceDate);
      startDate.setFullYear(startDate.getFullYear() + 1);
    } else {
      // Default to This month
      fromDate = this.getMonthStartDate(year, month);
      startDate = this.getMonthEndDate(year, month);
    }

    return {
      FromDate: this.formatLocalDate(fromDate),
      StartDate: this.formatLocalDate(startDate),
    };
  };

  // For Scheduled for filter
  onChangeFromToDate = (event) => {
    const selectedOption = event.value || event;
    const optionText = selectedOption.text;

    const dateRange = this.getDateRange(optionText);

    this.fromDate = dateRange.FromDate;
    this.toDate = dateRange.StartDate;
    this.selectedType = selectedOption;

    this.setState(
      {
        selectedType: selectedOption,
        fromDate: dateRange.FromDate,
        toDate: dateRange.StartDate,
      },
      () => {
        if (this.state.lot) {
          this.getAllReminder();
        }
      }
    );
  };

  // For Status filter
  onChangeStatus = (event) => {
    this.setState({
      statusData: event.value,
    });
    this.selectedStatus = event.value;
  };

  getItemListBasedOnLots = () => {
    const { LotId } = this.state;
    const { builderProfile } = LotId.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_ITEMS_LIST_BASE_ON_LOTS,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: LotId.value,
      },
      callback: (data) => {
        const smartAppListFormatted = [];
        data.data.map((app) =>
          smartAppListFormatted.push({
            text: app.itemName,
            value: app.itemName,
            id: app.id,
          })
        );
        this.setState({ itemListBasedOnLots: smartAppListFormatted });
      },
    });
  };

  createReminder = async () => {
    this.setState({ isLoading: true });
    try {
      const {
        LotId,
        Title,
        Description,
        ItemId,
        Frequency,
        StartDate,
        EndDate,
      } = this.state;

      if (!LotId) {
        console.error("LotId is missing");
        return;
      }

      const builderProfile = LotId.extensionValue.builderProfile;
      if (!builderProfile.builderHost) {
        console.error("builderProfile missing");
        return;
      }

      const payload = {
        Title,
        Description,
        LotId: LotId.value || "",
        ItemId: ItemId && ItemId.id ? ItemId.id : "",
        Frequency: Frequency.value || "",
        StartDate,
        EndDate,
      };

      const response = await fetch(
        `${builderProfile.builderHost}/api/v2/homeowner/maintainence/add`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "SiteOne_Services_token"
            )}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const finalResponse = await response.json();

      if (finalResponse.statusCode === 200) {
        this.setState(
          {
            show: false,
            Title: "",
            Description: "",
            ItemId: null,
            Frequency: null,
            StartDate: "",
            EndDate: "",
            maintenanceId: null,
            errorMessage: "",
            dateValidationError: "",
          },
          () => {
            this.props.dispatch({
              type: NotifyActionType.NOTIFY_SUCCESS,
              data: "Reminder created successfully",
            });
          }
        );
        this.getAllReminder();
      } else {
        this.props.dispatch({
          type: NotifyActionType.NOTIFY_ERROR,
          data: finalResponse.message || "Failed to create reminder",
        });
      }
    } catch (error) {
      this.props.dispatch({
        type: NotifyActionType.NOTIFY_ERROR,
        data: "An error occurred while creating the reminder",
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateReminder = async () => {
    this.setState({ isLoading: true });
    try {
      const {
        maintenanceId,
        LotId,
        Title,
        Description,
        ItemId,
        Frequency,
        StartDate,
        EndDate,
      } = this.state;
      if (!LotId) {
        console.error("LotId is missing");
        return;
      }

      const builderProfile = LotId.extensionValue.builderProfile;
      if (!builderProfile.builderHost) {
        console.error("builderProfile missing");
        return;
      }
      const payload = {
        Id: maintenanceId,
        Title,
        Description,
        LotId: LotId.value,
        ItemId: ItemId && ItemId.id ? ItemId.id : "",
        Frequency: Frequency.value,
        StartDate,
        EndDate,
      };
      const response = await fetch(
        `${builderProfile.builderHost}/api/v2/homeowner/maintainence/update`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "SiteOne_Services_token"
            )}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const finalResponse = await response.json();
      if (finalResponse.statusCode === 200) {
        this.setState(
          {
            show: false,
            Title: "",
            Description: "",
            ItemId: null,
            Frequency: null,
            StartDate: "",
            EndDate: "",
            maintenanceId: null,
            errorMessage: "",
            dateValidationError: "",
          },
          () => {
            this.props.dispatch({
              type: NotifyActionType.NOTIFY_SUCCESS,
              data: "Reminder updated successfully",
            });
          }
        );
        this.getAllReminder();
      } else {
        this.props.dispatch({
          type: NotifyActionType.NOTIFY_ERROR,
          data: finalResponse.message || "Failed to update reminder",
        });
      }
    } catch (error) {
      this.props.dispatch({
        type: NotifyActionType.NOTIFY_ERROR,
        data: "An error occurred while updating the reminder",
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getAllReminder = () => {
    const { lot, statusData, fromDate, toDate } = this.state;
    if (!lot || !lot.extensionValue) {
      return;
    }
    const { builderProfile } = lot.extensionValue;
    this.props.dispatch({
      type: LotActionType.GET_REMINDER_LIST,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: {
          LotId: lot.value,
          Status: statusData ? statusData : null,
          FromDate: fromDate ? fromDate : this.fromDate ? this.fromDate : null,
          ToDate: toDate ? toDate : this.toDate ? this.toDate : null,
        },
      },
      callback: (data) => {
        this.setState({ remindersList: data.data });
      },
    });
  };

  getSpecificReminder = (maintenanceId) => {
    const { lot } = this.state;
    const { homeownerLotSelectList } = this.props; // Get from props

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_SPECIFIC_REMINDER_DETAILS,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: {
          lotid: maintenanceId,
        },
      },
      callback: (response) => {
        const reminderData = response.data;
        const frequencyOption =
          ReminderFrequency.find((f) => f.text === reminderData.frequency) ||
          null;
        const formatDateForInput = (dateString) => {
          if (!dateString) return "";
          const date = Moment(dateString);
          return date.isValid() ? date.format("MM/DD/YYYY") : "";
        };
        const selectedLot = homeownerLotSelectList.find(
          (lot) => lot.value === reminderData.lotId
        );
        const selectedItem = reminderData.itemId
          ? {
              id: reminderData.itemId,
              value: reminderData.itemName,
              text: reminderData.itemName || "",
            }
          : null;
        const toDateInput = (dateStr) => {
          const date = new Date(dateStr);
          return isNaN(date) ? "" : date.toISOString().substring(0, 10); // "YYYY-MM-DD"
        };
        this.setState(
          {
            Title: reminderData.title || "",
            Description: reminderData.description || "",
            LotId: selectedLot || null,
            ItemId: selectedItem,
            Frequency: frequencyOption,
            StartDate: toDateInput(reminderData.startDate),
            EndDate: toDateInput(reminderData.endDate),
            maintenanceId: maintenanceId,
          },
          () => {
            if (selectedLot) {
              this.getItemListBasedOnLots();
            }
          }
        );
      },
    });
  };

  deleteReminder = (maintenanceId) => {
    const { lot } = this.state;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.DELETE_REMINDER,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: {
          lotid: maintenanceId,
        },
      },
      callback: () => {
        this.getAllReminder();
      },
    });
  };

  onchangeUpdateReminder = (maintenanceId, reminderDate) => {
    const { lot } = this.state;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.ONCHANGE_UPDATE_REMINDER,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: {
          reminderId: maintenanceId,
          reminderDate,
          lotId: lot.value,
        },
      },
      callback: () => {
        this.getAllReminder();
      },
    });
  };

  sortRemindersByTitle = () => {
    const { sortAscending, remindersList } = this.state;
    if (!Array.isArray(remindersList) || remindersList.length === 0) return;

    const sorted = [...remindersList].sort((a, b) => {
      const titleA = (a.title && a.title.toLowerCase()) || "";
      const titleB = (b.title && b.title.toLowerCase()) || "";
      if (titleA < titleB) return sortAscending ? -1 : 1;
      if (titleA > titleB) return sortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      remindersList: sorted,
      sortAscending: !sortAscending,
    });
  };

  // Date validation helper functions
  isValidDate = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  };

  parseDate = (dateString) => {
    return new Date(dateString);
  };

  validateDates = (startDate, endDate) => {
    let errors = [];

    // Validate Start Date
    // if (!startDate) {
    //   errors.push("Start Date is required");
    // } else if (!this.isValidDate(startDate)) {
    //   errors.push("Start Date must be a valid date");
    // }

    // Validate End Date
    // if (!endDate) {
    //   errors.push("End Date is required");
    // } else if (!this.isValidDate(endDate)) {
    //   errors.push("End Date must be a valid date");
    // }

    // Cross-validation if both dates are valid
    if (
      startDate &&
      endDate &&
      this.isValidDate(startDate) &&
      this.isValidDate(endDate)
    ) {
      const startDateObj = this.parseDate(startDate);
      const endDateObj = this.parseDate(endDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // normalize to midnight

      // End Date must be after or equal to Start Date
      if (endDateObj < startDateObj) {
        errors.push("End Date must be after Start Date");
      }

      // End Date must be greater than today
      if (endDateObj <= today) {
        errors.push("End Date must be greater than today");
      }
    }

    return errors;
  };

  handleReminderSubmit = () => {
    const { Title, Description, LotId, ItemId, Frequency, StartDate, EndDate } =
      this.state;

    // Basic field validation
    if (
      !Title ||
      Title.trim() === "" ||
      !Description ||
      Description.trim() === "" ||
      !LotId.value ||
      !Frequency.value ||
      !StartDate ||
      !EndDate
    ) {
      this.setState({
        errorMessage: "Please fill in all required fields.",
      });
      return;
    }

    // Date validation
    const dateErrors = this.validateDates(StartDate, EndDate);
    if (dateErrors.length > 0) {
      this.setState({
        dateValidationError: dateErrors[0], // Show first error
      });
      return;
    }

    // Clear any previous errors
    this.setState({
      errorMessage: "",
      dateValidationError: "",
    });

    if (this.state.maintenanceId) {
      this.updateReminder();
    } else {
      this.createReminder();
    }
  };

  render() {
    const {
      activeKey,
      lot,
      documents,
      selectedFilter,
      searchQuery,
      sortAscending,
      show,
      itemListBasedOnLots,
      LotId,
      ItemId,
      Frequency,
    } = this.state;
    const { homeownerLotSelectList } = this.props;
    const isDisabled =
      !Array.isArray(this.state.remindersList) ||
      this.state.remindersList.length === 0;
    const filteredReminders = this.getFilteredReminders();

    const startDate = this.state.StartDate
      ? new Date(this.state.StartDate)
      : "";
    const endDate = this.state.EndDate ? new Date(this.state.EndDate) : "";

    const formatDateForInput = (date) => {
      if (!date) return "";
      if (typeof date === "string") {
        // If it's already a string in YYYY-MM-DD format, return as is
        if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return date;
        }
        // If it's a date string, convert to Date object
        date = new Date(date);
      }
      if (date instanceof Date && !isNaN(date)) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }
      return "";
    };

    return (
      <div className="homeowner-maintenance-comtainer">
        <div
          className="project-document-wrapper homeowner-maintenance"
          style={{ padding: 15 }}
        >
          <Tab.Container
            id="left-tabs-example"
            className="document-tab"
            activeKey={activeKey}
            onSelect={(key) => this.setState({ activeKey: key })}
          >
            <Row className="clearfix">
              <div>
                <Col sm={3} className="maintenance-category">
                  <div>
                    <label className="control-label">Filter by Property</label>
                    <div className="control-label">
                      <div className="select-lot">
                        <Dropdown
                          onChange={(event) => this.onSelectLot(event, "lot")}
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          options={homeownerLotSelectList}
                          optionLabel="text"
                          onRemote={this.fetchLot}
                          value={lot}
                          name="lot"
                          placeholder="-- Please select"
                          style={{
                            width: "21vw",
                            display: "inline-block",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="control-label">Scheduled For</label>
                    <div className="control-label">
                      <Dropdown
                        name="reminder_period"
                        className="filestring-dropdown filter-dropdown"
                        style={{
                          width: "21vw",
                          display: "inline-block",
                        }}
                        optionLabel="text"
                        options={CHOICE_LIST}
                        value={this.state.selectedType || this.selectedType}
                        onChange={this.onChangeFromToDate}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="control-label">Status</label>
                    <div
                      ref={this.statusDropdownRef}
                      className="status-dropdown multiselect"
                      style={{ width: "100%", position: "relative" }}
                    >
                      <div
                        className="selectBox"
                        onClick={this.toggleStatusDropdown}
                      >
                        <select style={{ width: "100%" }}>
                          <option>
                            {this.state.statusData.length > 0
                              ? STATUS_LIST.filter((s) =>
                                  this.state.statusData.includes(s.value)
                                )
                                  .map((s) => s.text)
                                  .join(", ")
                              : "Select Status"}
                          </option>
                        </select>
                        <div
                          className="overSelect"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                          }}
                        />
                      </div>
                      {this.state.statusMenuOpen && (
                        <div
                          id="checkboxes"
                          style={{
                            display: "block",
                            border: "1px solid #dadada",
                            borderRadius: "6px",
                            padding: "10px",
                            background: "#fff",
                            position: "absolute",
                            zIndex: 999,
                            width: "21vw",
                          }}
                        >
                          <label
                            htmlFor="status-all"
                            style={{
                              display: "block",
                              padding: "5px 0",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="checkbox"
                              id="status-all"
                              checked={
                                this.state.statusData.length ===
                                STATUS_LIST.length
                              }
                              onChange={() => {
                                const allValues = STATUS_LIST.map(
                                  (s) => s.value
                                );
                                const isAllSelected =
                                  this.state.statusData.length ===
                                  STATUS_LIST.length;

                                this.setState(
                                  {
                                    statusData: isAllSelected ? [] : allValues,
                                  },
                                  () => {
                                    this.getAllReminder();
                                  }
                                );
                              }}
                              style={{
                                marginRight: "8px",
                                width: "15px",
                                height: "15px",
                              }}
                            />
                            All
                          </label>
                          {STATUS_LIST.map((status) => (
                            <label
                              key={status.value}
                              htmlFor={`status-${status.value}`}
                              style={{
                                display: "block",
                                padding: "5px 0",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                id={`status-${status.value}`}
                                checked={this.state.statusData.includes(
                                  status.value
                                )}
                                onChange={() =>
                                  this.handleStatusCheckboxChange(status.value)
                                }
                                style={{
                                  marginRight: "8px",
                                  width: "15px",
                                  height: "15px",
                                }}
                              />
                              {status.text}
                            </label>
                          ))}

                          {/* {STATUS_LIST.map((status) => (
                            <label
                              key={status.value}
                              htmlFor={`status-${status.value}`}
                              style={{
                                display: "block",
                                padding: "5px 0",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                id={`status-${status.value}`}
                                checked={this.state.statusData.includes(
                                  status.value
                                )}
                                onChange={() =>
                                  this.handleStatusCheckboxChange(status.value)
                                }
                                style={{ marginRight: "8px" }}
                              />
                              {status.text}
                            </label>
                          ))} */}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col sm={9} className="maintenance-listing-section">
                  <div className="heading-div">
                    <div className="name-sort-btn">
                      <button
                        className="name-btn"
                        type="button"
                        data-toggle="dropdown"
                        disabled={isDisabled}
                        onClick={this.sortRemindersByTitle}
                        style={
                          isDisabled
                            ? { opacity: 0.5, cursor: "not-allowed" }
                            : {}
                        }
                      >
                        Name
                        {sortAscending ? (
                          <i className="fa fa-angle-up" aria-hidden="true"></i>
                        ) : (
                          <i
                            className="fa fa-angle-down"
                            aria-hidden="true"
                          ></i>
                        )}
                      </button>
                    </div>

                    <div
                      className="search-container"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <i
                        className="fa fa-search"
                        style={{
                          position: "relative",
                          left: "30px",
                          pointerEvents: "none",
                          color: "rgb(159 155 155)",
                          fontSize: "16px",
                        }}
                        aria-hidden="true"
                      ></i>
                      <input
                        type="text"
                        placeholder="Search by Maintenance"
                        className="search-input"
                        style={{
                          padding: "7px 14px 6px 35px",
                          borderRadius: "50px",
                          border: "1px solid #ccc",
                          width: "250px",
                        }}
                        value={searchQuery}
                        onChange={(e) => {
                          this.setState({ searchQuery: e.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <Tab.Content
                    animation
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                    }}
                  >
                    <div className="content-maintenance">
                      <div className="filters-maintenance">
                        <button
                          className={`btn btn-sm filter-btns ${
                            selectedFilter === "All"
                              ? "btn-primary"
                              : "btn-default"
                          }`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={() => this.handleFilterClick("All")}
                        >
                          All
                        </button>
                        <button
                          className={`btn btn-sm filter-btns ${
                            selectedFilter === "HomeHub"
                              ? "btn-primary"
                              : "btn-default"
                          }`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={() => this.handleFilterClick("HomeHub")}
                        >
                          HomeHub Reminders
                        </button>
                        <button
                          className={`btn btn-sm filter-btns ${
                            selectedFilter === "YourReminders"
                              ? "btn-primary"
                              : "btn-default"
                          }`}
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={() =>
                            this.handleFilterClick("YourReminders")
                          }
                        >
                          Your Reminders
                        </button>
                      </div>
                      <div className="maintenance-cards-lists">
                        {filteredReminders.length === 0 ? (
                          <div className="no-results-message">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                            No reminders found matching your criteria
                          </div>
                        ) : (
                          filteredReminders.map((ele) => (
                            <MaintenanceCard
                              key={Math.random()}
                              id={ele.id}
                              isBuilderUploaded={ele.isBuilderUploaded}
                              title={ele.title}
                              description={ele.description}
                              status={ele.status}
                              date={ele.remindDate}
                              onMarkAsRead={(checked, id, reminderDate) => {
                                if (checked) {
                                  this.onchangeUpdateReminder(id, reminderDate);
                                } else {
                                }
                              }}
                              onDelete={(id) => {
                                this.deleteReminder(id);
                              }}
                              onEdit={(id) => {
                                this.setState({
                                  maintenanceId: id,
                                  show: true,
                                });
                                this.getSpecificReminder(id);
                              }}
                            />
                          ))
                        )}
                      </div>
                    </div>
                  </Tab.Content>
                </Col>
              </div>
            </Row>
          </Tab.Container>
        </div>
        {show && (
          <Drawer
            isOpen={show}
            onClose={this.handleCloseModal}
            title={this.state.maintenanceId ? "Edit Reminder" : "New Reminder"}
            position="right"
          >
            <div className="new-reminder-container">
              <form className="reminder-form">
                <label className="control-label">
                  Title<span className="text-danger"> *</span>
                </label>

                <input
                  name="Title"
                  value={this.state.Title}
                  type="text"
                  placeholder="Reminder Title"
                  maxLength={50}
                  className="input-field"
                  onChange={(event) => {
                    this.setState({
                      Title: event.target.value,
                    });
                  }}
                />
                <label className="control-label">
                  Description<span className="text-danger"> *</span>
                </label>

                <textarea
                  name="Description"
                  value={this.state.Description}
                  placeholder="Enter Description"
                  className="text-area"
                  maxLength={150}
                  onChange={(event) => {
                    this.setState({
                      Description: event.target.value,
                    });
                  }}
                />
                <div>
                  <label className="control-label">Property</label>
                  <span className="text-danger"> *</span>
                  <div className="control-label">
                    <div className="select-lot">
                      <Dropdown
                        onChange={this.onSelectLotID}
                        filter={true}
                        className="filestring-dropdown filter-dropdown"
                        options={homeownerLotSelectList}
                        optionLabel="text"
                        name="LotId"
                        value={LotId}
                        placeholder="-- Please select"
                        style={{
                          width: "100%",
                          display: "inline-block",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="control-label">Inventory</label>
                  {/* <span className="text-danger"> *</span> */}
                  <div className="control-label">
                    <div className="select-lot">
                      <Dropdown
                        id="inventoryDropdown"
                        onChange={(ref) => {
                          this.onSelectItemID(ref, "ItemId");
                        }}
                        filter={true}
                        className="filestring-dropdown filter-dropdown"
                        options={itemListBasedOnLots || []}
                        optionLabel="text"
                        name="ItemId"
                        value={ItemId}
                        placeholder="-- Please select"
                        style={{
                          width: "100%",
                          display: "inline-block",
                        }}
                        showClear={true}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="control-label">Frequency</label>
                  <span className="text-danger"> *</span>
                  <div className="control-label">
                    <div className="select-lot">
                      <Dropdown
                        onChange={(event) =>
                          this.setState({
                            Frequency: event.value,
                          })
                        }
                        filter={true}
                        className="filestring-dropdown filter-dropdown"
                        options={ReminderFrequency}
                        optionLabel="text"
                        name="Frequency"
                        value={Frequency}
                        placeholder="-- Please select"
                        style={{
                          width: "100%",
                          display: "inline-block",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="date-group" style={{ marginBottom: "40px" }}>
                  <div className="date-picker">
                    <label>Start Date</label>
                    <span className="text-danger"> *</span>
                    <input
                      name="StartDate"
                      value={formatDateForInput(startDate)}
                      type="date"
                      className="input-field"
                      placeholder="Start Date"
                      min={(() => {
                        const tomorrow = new Date();
                        tomorrow.setDate(tomorrow.getDate() + 1);
                        return tomorrow.toISOString().split("T")[0];
                      })()}
                      onChange={(event) => {
                        const newStart = event.target.value;
                        const { EndDate } = this.state;
                        const tomorrow = new Date();
                        tomorrow.setDate(tomorrow.getDate() + 1);
                        const tomorrowStr = tomorrow
                          .toISOString()
                          .split("T")[0];

                        // Prevent past and current dates
                        if (newStart && newStart < tomorrowStr) {
                          this.setState({
                            dateValidationError:
                              "Start Date cannot be in the past and current date",
                          });
                          return;
                        }

                        // Validate dates when start date changes
                        const dateErrors = this.validateDates(
                          newStart,
                          EndDate
                        );

                        this.setState({
                          StartDate: newStart,
                          dateValidationError:
                            dateErrors.length > 0 ? dateErrors[0] : "",
                        });
                      }}
                    />
                  </div>
                  <div className="date-picker">
                    <label>End Date</label>
                    <span className="text-danger"> *</span>
                    <input
                      name="EndDate"
                      value={formatDateForInput(endDate)}
                      type="date"
                      className="input-field"
                      placeholder="End Date"
                      min={
                        this.state.StartDate ||
                        new Date().toISOString().split("T")[0]
                      } // Set minimum to start date or today
                      onChange={(event) => {
                        const newEnd = event.target.value;
                        const { StartDate } = this.state;

                        // Validate dates when end date changes
                        const dateErrors = this.validateDates(
                          StartDate,
                          newEnd
                        );

                        this.setState({
                          EndDate: newEnd,
                          dateValidationError:
                            dateErrors.length > 0 ? dateErrors[0] : "",
                        });
                      }}
                    />
                  </div>
                  {this.state.dateValidationError && (
                    <p className="maintenance-errormsg">
                      {this.state.dateValidationError}
                    </p>
                  )}
                </div>
                {this.state.errorMessage ? (
                  <p className="maintenance-errormsg">
                    {this.state.errorMessage}
                  </p>
                ) : (
                  ""
                )}
                <button
                  type="button"
                  className="submit-btn"
                  onClick={this.handleReminderSubmit}
                  disabled={
                    this.state.isLoading || this.state.dateValidationError
                  }
                >
                  {this.state.isLoading ? (
                    <div className="loader-container">
                      <i
                        className="fa fa-spinner fa-spin"
                        aria-hidden="true"
                      ></i>
                      <span>Processing...</span>
                    </div>
                  ) : this.state.maintenanceId ? (
                    "Edit Reminder"
                  ) : (
                    "Save Reminder"
                  )}
                </button>
              </form>
            </div>
          </Drawer>
        )}
        {!show && (
          <button
            className="add-document-btn"
            type="button"
            onClick={this.handleOpenModal}
          >
            + Add Reminder
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots,
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
  };
};

export default connect(mapStateToProps)(HomeOwnerMaintainance);



// WEBPACK FOOTER //
// ./src/Lots/Containers/homeowner-maintaince.js